import {EntityService} from '../../../service/EntityService';

export class TenantInvoiceSettingMasterService extends EntityService {

  static entity = 'app/tenant-invoice-setting-master';

  static updateByGroup(id: string, groupTypeCode: string, data: any): Promise<any> {
    return this.axios.put(`${this.entity}/${id}/list-by-group-code?groupTypeCode=${groupTypeCode}`, data).then(res => res.data);
  }

}
